var map = {
	"./s1.png": "gJZA",
	"./s2.png": "Jk5r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sRvP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/s.*\.png$
// module id = sRvP
// module chunks = 1